import { useContext } from "react";

import { NetworkContext } from "@nens/ranalib";

import EmptyClock from "@/images/empty-clock.png";
import EmptyFiles from "@/images/empty-files.png";
import EmptyFolderCircle from "@/images/empty-folder-circle.png";
import EmptyFolder from "@/images/empty-folder.png";
import EmptyJobs from "@/images/empty-jobs.png";
import EmptyPublications from "@/images/empty-publications.png";
import EmptySchematisation from "@/images/empty-schematisation.png";
import EmptyUsers from "@/images/empty-users.png";

export const useIconSrc = (icon?: string) => {
  const { noNetworkImageSrc } = useContext(NetworkContext);
  switch (icon) {
    case "project":
      return EmptyFolderCircle;
    case "folder":
      return EmptyFolder;
    case "files":
      return EmptyFiles;
    case "clock":
      return EmptyClock;
    case "user":
      return EmptyUsers;
    case "job":
      return EmptyJobs;
    case "publication":
      return EmptyPublications;
    case "schematisation":
      return EmptySchematisation;
    case "no-internet":
      return noNetworkImageSrc;
    default:
      return null;
  }
};
